import { format } from "date-fns";
import { pl } from "date-fns/locale";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { truncateText } from "@/components/equipment/equipmentLabels";

export interface EquipmentGearRow {
  id: string;
  type: string;
  name: string;
  serialNumber?: string | null;
  condition?: string | null;
  status: string;
  date?: string | null;
  canReturn: boolean;
  onReturn: () => void;
}

export function EquipmentGearTable({
  title,
  empty,
  rows,
}: {
  title: string;
  empty: string;
  rows: EquipmentGearRow[];
}) {
  return (
    <div>
      <h3 className="mb-2 text-sm font-medium">{title}</h3>
      {rows.length === 0 ? (
        <p className="py-4 text-center text-sm text-muted-foreground">{empty}</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Typ</TableHead>
              <TableHead>Nazwa</TableHead>
              <TableHead>Nr seryjny</TableHead>
              <TableHead>Stan</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Data</TableHead>
              <TableHead>Akcje</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <Badge variant="secondary">{row.type}</Badge>
                </TableCell>
                <TableCell className="font-medium">{row.name}</TableCell>
                <TableCell>{row.serialNumber || "—"}</TableCell>
                <TableCell className="max-w-[200px] text-sm text-muted-foreground">
                  {truncateText(row.condition, 80)}
                </TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>
                  {row.date ? format(new Date(row.date), "dd.MM.yyyy", { locale: pl }) : "—"}
                </TableCell>
                <TableCell>
                  {row.canReturn && (
                    <Button size="sm" variant="outline" onClick={row.onReturn}>
                      Zdaj
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
